import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';

const AddWard = () => {
    const [loading, setLoading] = useState(false);

    const onFinish = (values) => {
        setLoading(true);
        axios.post('https://ward3-chandrapur-api.palikaapp.com/api/ward/save', {
            id: values.id,
            name: values.name,
            phone: values.phone,
            email: values.email,
        })
        .then(() => {
            message.success('Municipal Ward saved successfully!');
            setLoading(false);
        })
        .catch((error) => {
            message.error('Failed to save Municipal Ward.');
            console.error('Error:', error);
            setLoading(false);
        });
    };

    return (
        <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
            
                <Header />
                <div className="lg:w-1/5 bg-gray-100 pt-20">
                <Sidebar />
            </div>
            <div className="lg:w-4/5 p-20 pt-20 mt-10">
                <h1 className="text-xl lg:text-2xl font-bold mb-6 text-center lg:text-center">
                    वडा थप गर्ने फारम
                </h1>
                <div className="flex justify-center">
                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        className="w-full max-w-md bg-white p-6 shadow-lg rounded-md"
                    >
                        <Form.Item
                            label="नाम"
                            name="name"
                            rules={[{ required: true, message: 'Please input the name!' }]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="फोन"
                            name="phone"
                            rules={[{ required: true, message: 'Please input the phone number!' }]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="इमेल"
                            name="email"
                            rules={[
                                { required: true, message: 'Please input the email!' },
                                { type: 'email', message: 'Please enter a valid email!' },
                            ]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md"
                            >
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default AddWard;
